import { Flex } from 'antd'
import { Outlet } from 'react-router-dom'

import { useStyles } from './styles'

export const AuthenticationLayout = () => {
  const { styles } = useStyles()

  return (
    <Flex style={{ width: '100%', maxHeight: '100vh' }}>
      <div className={styles.imageWrapper}>
        <img src="/auth.svg" className={styles.image} />
      </div>
      <Flex align="center" justify="center" flex={1}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </Flex>
    </Flex>
  )
}
